// extracted by mini-css-extract-plugin
export default {"primary_button":"primary_primary_button__Gg9D1","e_disabled":"primary_e_disabled__LbJH-"};